__turbopack_context__.v({
  "button": "styles-module-scss-module__UvzYBW__button",
  "error": "styles-module-scss-module__UvzYBW__error",
  "iconProcess": "styles-module-scss-module__UvzYBW__iconProcess",
  "list": "styles-module-scss-module__UvzYBW__list",
  "listItem": "styles-module-scss-module__UvzYBW__listItem",
  "radioBtn": "styles-module-scss-module__UvzYBW__radioBtn",
  "radioBtnDisabled": "styles-module-scss-module__UvzYBW__radioBtnDisabled",
  "root": "styles-module-scss-module__UvzYBW__root",
  "text": "styles-module-scss-module__UvzYBW__text",
  "textVerified": "styles-module-scss-module__UvzYBW__textVerified",
  "title": "styles-module-scss-module__UvzYBW__title",
  "verifiedIcon": "styles-module-scss-module__UvzYBW__verifiedIcon",
});
